<template>
  <div class="dashboard-menu left-nav">
    <b-list-group class="d-none d-sm-block">
      <b-list-group-item  v-for="item in nav" :key="item.title">
        <router-link :class="item.linkClass" :to="item.to">
          <div class="icon-container">
            <i v-if="item.icon" :class="item.icon"></i>
            <img v-if="item.src" :src="item.src">
            <svg class="icon" v-if="item.symbol"><use :xlink:href="`/static/images/dashboard/sprites.svg#${item.symbol}`"/></svg>
          </div>
          <span>{{item.title}}</span>
        </router-link>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
export default {
  props: ['nav']
}
</script>

<style scoped lang="scss">
@import '~scss/colors';

  /* Profile Page - sub-navigation */
  .left-nav {
    background: $white;
    overflow: hidden;
  }
  .icon-container {
    margin-right: 12px;
    height:30px;
    svg, img {
      height:30px;
      width:30px;
      &:hover{
        cursor: pointer;
        opacity: 1;
      }
    }
  }
  .sub-menu-body {
    padding-bottom: 60px;
  }

  $width: 84px;

  // With the extra dashboard menu items, the menu nav can be taller than the window on relatively
  // normal window heights. It's better UI if the user can see all of the items at once. We adjust
  // the padding in increments, which is simple to implement and scales to multiple numbers of menu
  // items (we can see between 4 and 6 currently)
  .dashboard-menu .list-group-item a {
    @media only screen and (max-height: 700px) {
      padding: 20px 30px;
    }
    @media only screen and (max-height: 600px) {
      padding: 15px 20px;
    }
  }

  @media only screen and (max-width: 767px) {
    .dashboard-menu {
      width: $width;
    }
    .sub-menu-header,
    .list-group-item {
      span {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/LeftNav.vue